// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.one-ticket[data-v-13a80548] {\n  width: 100%;\n  max-width: 737px;\n  margin: 40px auto;\n}\n.one-ticket__btn[data-v-13a80548] {\n  width: auto;\n  margin-bottom: 30px;\n  padding: 0 50px;\n}\n.one-ticket__message[data-v-13a80548] {\n  margin-top: 20px;\n}\n.one-ticket__section[data-v-13a80548] {\n  margin-bottom: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
